import { Form, Checkbox, Col, Row } from 'antd';
import FloatingFormItem from '../../FloatingFormItem';
import InputDecimal from '../../InputDecimal';
import SectionCard from '../../SectionCard';
import SelectInvoicePresumedCode from '../SelectPresumedCode';

interface Props {
  prefixPath?: string[];
}

export default function PresumedCreditIbsCbsFormFields({
  prefixPath = ['itemTaxes', 'ibsCbs'],
}: Props) {
  const form = Form.useFormInstance();
  const enableIbsCbsCredPres = Form.useWatch('enableIbsCbsCredPres', form);

  return (
    <>
      <div>
        <Form.Item name="enableIbsCbsCredPres" valuePropName="checked">
          <Checkbox style={{ fontWeight: 600 }}>
            Exibir Grupo Crédito Presumido - IBS/CBS
          </Checkbox>
        </Form.Item>
      </div>

      <div style={{ display: enableIbsCbsCredPres ? 'block' : 'none' }}>
        <SectionCard
          visible={enableIbsCbsCredPres}
          title="Crédito Presumido - IBS/CBS"
          style={{ marginBottom: 24 }}
        >
          <Row gutter={[16, 16]}>
            <Col span={24}>
              <FloatingFormItem
                name={[...prefixPath, 'classificationCodePresumedCredit']}
                label="Cód. de Classificação do CP"
              >
                <SelectInvoicePresumedCode allowClear />
              </FloatingFormItem>
            </Col>
          </Row>
        </SectionCard>

        <SectionCard
          visible={enableIbsCbsCredPres}
          title="Crédito Presumido - IBS"
          style={{ marginBottom: 24 }}
        >
          <Row gutter={[16, 16]}>
            <Col span={24} sm={12} md={6}>
              <FloatingFormItem
                label="Crédito Presumido (%)"
                name={[...prefixPath, 'ibsPresumedCreditPercentage']}
              >
                <InputDecimal fractions={4} />
              </FloatingFormItem>
            </Col>

            <Col span={24} sm={12} md={6}>
              <FloatingFormItem
                label="Valor Crédito Presumido"
                name={[...prefixPath, 'ibsPresumedCreditValue']}
              >
                <InputDecimal />
              </FloatingFormItem>
            </Col>

            <Col span={24} sm={12} md={6}>
              <FloatingFormItem
                label="Valor CP em Condição Suspensiva"
                name={[
                  ...prefixPath,
                  'ibsPresumedCreditSuspensiveConditionValue',
                ]}
              >
                <InputDecimal />
              </FloatingFormItem>
            </Col>
          </Row>
        </SectionCard>

        <SectionCard
          visible
          title="Crédito Presumido - CBS"
          style={{ marginBottom: 24 }}
        >
          <Row gutter={[16, 16]}>
            <Col span={24} sm={12} md={6}>
              <FloatingFormItem
                label="Crédito Presumido (%)"
                name={[...prefixPath, 'cbsPresumedCreditPercentage']}
              >
                <InputDecimal fractions={4} />
              </FloatingFormItem>
            </Col>

            <Col span={24} sm={12} md={6}>
              <FloatingFormItem
                label="Valor Crédito Presumido"
                name={[...prefixPath, 'cbsPresumedCreditValue']}
              >
                <InputDecimal />
              </FloatingFormItem>
            </Col>

            <Col span={24} sm={12} md={6}>
              <FloatingFormItem
                label="Valor CP em Condição Suspensiva"
                name={[
                  ...prefixPath,
                  'cbsPresumedCreditSuspensiveConditionValue',
                ]}
              >
                <InputDecimal />
              </FloatingFormItem>
            </Col>
          </Row>
        </SectionCard>
      </div>
    </>
  );
}
